'use strict';

(function () {
  var SAVE_DEBOUNCE = 800;

  function initGiftBlock(block) {
    if (block.dataset.giftInited) return;
    block.dataset.giftInited = '1';

    var toggle  = block.querySelector('[data-gift-toggle]');
    var panel   = block.querySelector('[data-gift-panel]');
    var summaryText = block.querySelector('[data-gift-summary-text]');
    var openNoteBtn = block.querySelector('[data-gift-open-note]');
    var openNoteLabel = block.querySelector('[data-gift-open-note-label]');
    var modal   = block.querySelector('[data-gift-note-modal]');

    if (!toggle || !panel) return;

    // The popup is moved to the end of <body> so it always escapes the cart
    // drawer's own transformed/scrolling box (a nested position:fixed panel
    // can get clipped or mis-positioned inside a transformed ancestor —
    // this sidesteps that regardless of where the gift block itself lives).
    // The cart drawer replaces its whole footer markup (fresh modal, same
    // gift_uid) on every quantity change, so the *previous* copy already
    // sitting in <body> is stale — remove it by matching uid before moving
    // the new one in, rather than leaving an orphaned duplicate behind.
    if (modal) {
      var giftUid = modal.dataset.giftUid;
      if (giftUid) {
        var stale = document.body.querySelector('[data-gift-note-modal][data-gift-uid="' + giftUid + '"]');
        if (stale && stale !== modal) stale.remove();
      }
      if (modal.parentElement !== document.body) document.body.appendChild(modal);
    }

    var preview  = modal ? modal.querySelector('[data-gift-preview]') : null;
    var previewText = modal ? modal.querySelector('[data-gift-preview-text]') : null;
    var textarea = modal ? modal.querySelector('[data-gift-textarea]') : null;
    var counter  = modal ? modal.querySelector('[data-gift-counter]') : null;
    var fontBtns = modal ? modal.querySelectorAll('[data-gift-font]') : [];
    var saveBtn  = modal ? modal.querySelector('[data-gift-note-save]') : null;
    var removeBtn = modal ? modal.querySelector('[data-gift-note-remove]') : null;
    var closeEls = modal ? modal.querySelectorAll('[data-gift-note-close]') : [];

    // Save button reuses the sitewide .btn-wave hover effect — wire it up
    // directly rather than waiting for button-wave.js's own DOMContentLoaded
    // scan, since the cart drawer re-renders this markup fresh on every
    // quantity change (button-wave.js exposes .init for exactly this).
    if (saveBtn && window.BabucoWaveButton && typeof window.BabucoWaveButton.init === 'function') {
      window.BabucoWaveButton.init(saveBtn);
    }

    // Derived from the textarea's own maxlength, matching the pattern used
    // in assets/personalization.js, rather than a hardcoded constant.
    var maxChars = textarea ? parseInt(textarea.getAttribute('maxlength'), 10) : 200;
    if (!maxChars) maxChars = 200;

    var saveTimer = null;

    function updateSummary(message) {
      if (summaryText) {
        summaryText.textContent = message.trim() ? message : 'No note added yet — totally optional.';
        summaryText.classList.toggle('has-content', !!message.trim());
      }
      if (openNoteLabel) openNoteLabel.textContent = message.trim() ? 'Edit gift note' : 'Add a gift note';
    }

    // Toggle open/close (the outer "Make it a gift" switch, not the popup)
    toggle.addEventListener('change', function () {
      var isOn = toggle.checked;
      panel.setAttribute('aria-hidden', isOn ? 'false' : 'true');
      toggle.setAttribute('aria-expanded', isOn ? 'true' : 'false');
      if (!isOn) {
        saveGiftAttributes('', block);
      } else if (textarea && textarea.value) {
        // Re-flagging as a gift with an existing message should also persist
        // the flag right away rather than waiting on the next keystroke.
        saveGiftAttributes(textarea.value, block);
      }
    });

    if (!modal) return;

    function openModal() {
      modal.hidden = false;
      requestAnimationFrame(function () {
        modal.classList.add('is-open');
        modal.setAttribute('aria-hidden', 'false');
      });
      document.addEventListener('keyup', onKeyUp);
      if (textarea) textarea.focus();
    }

    function closeModal() {
      // A pause mid-typing that hasn't hit the debounce yet shouldn't be
      // lost just because the popup was closed via the X/overlay rather
      // than the explicit Save button.
      if (saveTimer && textarea) {
        clearTimeout(saveTimer);
        saveTimer = null;
        saveGiftAttributes(textarea.value, block);
      }
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.removeEventListener('keyup', onKeyUp);
      setTimeout(function () { modal.hidden = true; }, 250);
    }

    function onKeyUp(e) { if (e.key === 'Escape') closeModal(); }

    if (openNoteBtn) openNoteBtn.addEventListener('click', openModal);
    closeEls.forEach(function (el) { el.addEventListener('click', closeModal); });

    if (saveBtn) {
      saveBtn.addEventListener('click', function () {
        var text = textarea ? textarea.value : '';
        clearTimeout(saveTimer);
        saveTimer = null;
        saveGiftAttributes(text, block);
        updateSummary(text);
        closeModal();
      });
    }

    if (removeBtn) {
      removeBtn.addEventListener('click', function () {
        if (textarea) textarea.value = '';
        clearTimeout(saveTimer);
        saveTimer = null;
        updateCounter(counter, 0, maxChars);
        updatePreview(previewText, '');
        scalePreviewFont(previewText, 0);
        saveGiftAttributes('', block);
        updateSummary('');
        closeModal();
      });
    }

    // Font selection — update preview data-font attribute
    fontBtns.forEach(function (btn) {
      btn.addEventListener('change', function () {
        if (btn.checked && preview) {
          preview.dataset.font = btn.value;
        }
      });
    });

    // Set initial font + rehydrate preview/counter state from server-rendered value
    var checkedFont = modal.querySelector('[data-gift-font]:checked');
    if (checkedFont && preview) preview.dataset.font = checkedFont.value;

    if (textarea) {
      updateCounter(counter, textarea.value.length, maxChars);
      updatePreview(previewText, textarea.value);
      scalePreviewFont(previewText, textarea.value.length);

      textarea.addEventListener('input', function () {
        var text = textarea.value.slice(0, maxChars);
        if (textarea.value !== text) textarea.value = text;

        updateCounter(counter, text.length, maxChars);
        updatePreview(previewText, text);
        scalePreviewFont(previewText, text.length);

        clearTimeout(saveTimer);
        saveTimer = setTimeout(function () {
          saveGiftAttributes(text, block);
        }, SAVE_DEBOUNCE);
      });
    }
  }

  function updateCounter(el, count, maxChars) {
    if (!el) return;
    el.textContent = count + '/' + maxChars;
    el.classList.toggle('is-near-limit', count >= maxChars - 20);
  }

  // Shrinks the preview text as the message gets longer so it keeps fitting
  // the card without the browser's 3-line clamp cutting it off with "…".
  // Tuned against a 200-char message: short notes stay large and confident,
  // long ones scale down in steps rather than truncating.
  function scalePreviewFont(el, length) {
    if (!el) return;
    var size;
    if (length <= 50) size = '1.3rem';
    else if (length <= 90) size = '1.15rem';
    else if (length <= 130) size = '1rem';
    else if (length <= 160) size = '0.88rem';
    else size = '0.78rem';
    el.style.fontSize = size;
  }

  function updatePreview(el, text) {
    if (!el) return;
    if (text.trim()) {
      el.textContent = text;
      el.classList.add('has-content');
    } else {
      el.textContent = 'Your message will appear here…';
      el.classList.remove('has-content');
    }
  }

  function saveGiftAttributes(message, block) {
    var fontBtn = block.querySelector('[data-gift-font]:checked');
    var font    = fontBtn ? fontBtn.value : 'Classic';
    var toggle  = block.querySelector('[data-gift-toggle]');
    var isGift  = toggle && toggle.checked;

    // Note: deliberately does NOT touch `note` — the message lives entirely
    // in the "Gift Message" attribute below. Posting `note` here used to
    // fight the separate cart-note textarea (assets/cart.js CartNote),
    // silently overwriting whatever the customer typed there.
    fetch(routes.cart_update_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: {
          'Gift Message': isGift ? message : '',
          'Gift Message Font': isGift ? font : '',
          'Is Gift': isGift ? 'Yes' : '',
        },
      }),
    }).catch(function () {
      // Silently fail — message will still appear if user re-enters at cart
    });
  }

  function initAll() {
    document.querySelectorAll('[data-gift-block]').forEach(initGiftBlock);
  }

  document.addEventListener('DOMContentLoaded', initAll);

  // The cart drawer replaces its entire footer markup (fresh, un-initialised
  // nodes with server-rendered attribute values) on every quantity change —
  // re-run init so the new instance picks up listeners again.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, initAll);
  }

  window.BabucoGift = { initAll: initAll };
})();
